import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

interface WidgetSettings {
  disableMyLocation: boolean;
}

const DEFAULT_WIDGET_SETTINGS: WidgetSettings = {
  disableMyLocation: false,
};

export const WidgetSettingsContext = createContext<WidgetSettings>(
  DEFAULT_WIDGET_SETTINGS,
);

export function useWidgetSettings(): WidgetSettings {
  return useContext(WidgetSettingsContext);
}
